import ApiServices from '@/services/api'
import globalMixin from '@/mixins'
let that = globalMixin.methods

// --->>>>>>>>>>>>>>>   Fetch Service Provider List api call   <<<<<<<<<<<<<<---
const FETCH_SERVICE_PROVIDER = ({commit}) => {
  return ApiServices.fetchServiceProvider()
    .then(response => {
      commit('fetchServiceProvider', response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Fetch Service Provider List api call   <<<<<<<<<<<<<<---
const FETCH_RATES = ({commit}) => {
  return ApiServices.fetchRates()
    .then(response => {
      commit('fetchRates', response)
      // console.log("fetchRates=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   All Site List api call   <<<<<<<<<<<<<<---
const SITE_LIST = ({commit}, data) => {
  return ApiServices.getSiteList(data)
    .then(response => {
      commit('getSiteList', response)
      // console.log("getSiteList=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   All Site List api call   <<<<<<<<<<<<<<---
const SITE_DETAILS = ({ commit }, data) => {
  return ApiServices.getSiteDetail(data)
    .then(response => {
      commit('getSiteDetails', response)
      // console.log("getSiteDetails=====", response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Add Site api call   <<<<<<<<<<<<<<---
const ADD_SITE = ({commit}, data) => {
  return ApiServices.addSite(data)
    .then(response => {
      commit('addSite', response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}

// --->>>>>>>>>>>>>>>   Updae Site api call   <<<<<<<<<<<<<<---
const UPDATE_SITE = ({ commit }, data) => {
  return ApiServices.updateSite(data)
    .then(response => {
      commit('updateSite', response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}

const CHANGE_SERVICE_PROVIDER = ({ commit }, data) => {

  return ApiServices.changeServiceProvider(data)
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
};

const SITE_QUOTE_PART_TEMPLATE = ({}, data) => {
  return ApiServices.getSiteQuotePartTemplate(data)
    .then(response => {
      return response
    })
}

const SITE_QUOTE_PART_UPLOAD = ({}, data) => {
  return ApiServices.uploadSiteQuotePart(data)
    .then(response => {
      that.SUCCESS_TOAST_MSG(response.message)
      return response
    })
}

export default {
  FETCH_SERVICE_PROVIDER,
  FETCH_RATES,
  SITE_LIST,
  SITE_DETAILS,
  ADD_SITE,
  UPDATE_SITE,
  CHANGE_SERVICE_PROVIDER,
  SITE_QUOTE_PART_TEMPLATE,
  SITE_QUOTE_PART_UPLOAD
}



// WEBPACK FOOTER //
// ./src/store/modules/siteManagement/actions.js